// extracted by mini-css-extract-plugin
module.exports = {"gradientDark1":"#202d38","dismissButton":"DismissButton__dismissButton"};